import React, { FC } from 'react';

import { StyledTabCharacteristicWrapper, StyledTabCharacteristicValue } from './styled';

export type TabCharacteristicsProps = {
    name: string;
    value: string;
};

type TProps = {
    data: TabCharacteristicsProps[];
};

export const TabCharacteristics: FC<TProps> = ({ data }) => {
    return (
        <>
            {data.map((item: TabCharacteristicsProps) => (
                <StyledTabCharacteristicWrapper key={item.name}>
                    <StyledTabCharacteristicValue>{item.name}</StyledTabCharacteristicValue>
                    <StyledTabCharacteristicValue isTextRight>{item.value}</StyledTabCharacteristicValue>
                </StyledTabCharacteristicWrapper>
            ))}
        </>
    );
};
